import React, { useState } from 'react';
import KLOtpInput from '../../KLOtpInput';
import KLButton from '../../KLButton';
import { Wrapper, Cooldown, ErrorText, ResendRow } from './styles';

interface OtpStepProps {
  onSubmit: (code: string) => void;
  onResend: () => void;
  cooldownSeconds: number;
  isSubmitting: boolean;
  error?: string;
}

const OTP_LENGTH = 6;

const OtpStep: React.FC<OtpStepProps> = ({
  onSubmit,
  onResend,
  cooldownSeconds,
  isSubmitting,
  error,
}) => {
  const [code, setCode] = useState('');

  const handleSubmit = () => {
    if (code.length === OTP_LENGTH) onSubmit(code);
  };

  return (
    <Wrapper>
      <KLOtpInput
        length={OTP_LENGTH}
        onChange={setCode}
        // Submit only via the explicit button so we don't double-fire
        // verify-otp (the backend consumes the OTP record on first success).
        onComplete={() => {}}
        disabled={isSubmitting}
      />
      {error && <ErrorText role="alert">{error}</ErrorText>}
      <KLButton
        title="אימות קוד"
        onClick={handleSubmit}
        disabled={code.length !== OTP_LENGTH || isSubmitting}
        loading={isSubmitting}
      />
      <ResendRow>
        <button
          type="button"
          onClick={onResend}
          disabled={cooldownSeconds > 0 || isSubmitting}
        >
          שלחו קוד חדש
        </button>
        {cooldownSeconds > 0 && (
          <Cooldown>{`(אפשר לשלוח שוב בעוד ${cooldownSeconds} שניות)`}</Cooldown>
        )}
      </ResendRow>
    </Wrapper>
  );
};

export default OtpStep;
